import React from "react";
import { useIntl } from "react-intl";

import { RichText } from "@learningblocks/shared-components/lib/RichText";

import { TableCellProps } from "../types";
import { titleCellClass } from "../TableQuestion.css";

export interface TitleCellProps
  extends Pick<TableCellProps, "cellId" | "text" | "colspan"> {
  bgColor?: string;
}

export const TitleCell: React.FC<TitleCellProps> = ({
  cellId,
  text,
  colspan,
  bgColor,
}) => {
  const intl = useIntl();

  const translatedText = text
    ? intl.formatMessage({ id: text, defaultMessage: text })
    : "";

  const style = {
    ...(bgColor && { backgroundColor: bgColor }),
  };

  return (
    <th
      key={cellId}
      className={titleCellClass}
      colSpan={colspan ? Number(colspan) : undefined}
      scope="col"
      style={style}
    >
      <RichText value={translatedText} />
    </th>
  );
};
